import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '@/store/userSlice';
import { apiFetch } from '@/lib/api';
import type { User } from '@/store/userSlice';

interface RegisterResponse {
  user: User;
  access_token: string;
}

const LOGIN_PATTERN = /^[a-zA-Z0-9_.-]+$/;

export function useRegisterPage() {
  const navigate = useNavigate();
  const setAuth = useUserStore((s) => s.setAuth);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    const trimmedLogin = login.trim();
    if (trimmedLogin.length < 3 || !LOGIN_PATTERN.test(trimmedLogin)) {
      setError('Логин: минимум 3 символа — латиница, цифры, «.», «-», «_»');
      return;
    }
    if (password.length < 6) {
      setError('Пароль — минимум 6 символов');
      return;
    }
    if (password !== passwordConfirm) {
      setError('Пароли не совпадают');
      return;
    }

    setLoading(true);
    try {
      const res = await apiFetch('/api/v1/auth/register', {
        method: 'POST',
        body: JSON.stringify({ login: trimmedLogin, password }),
      });
      if (!res.ok) {
        const data = (await res.json().catch(() => null)) as { error?: string } | null;
        setError(data?.error ?? 'Не удалось зарегистрироваться. Попробуйте позже.');
        return;
      }

      const data = (await res.json()) as RegisterResponse;
      // Автологин: дальше — форма данных организации (гейт до первого сохранения)
      setAuth(data.access_token, data.user);
      navigate('/profile', { replace: true });
    } catch {
      setError('Ошибка сети. Проверьте подключение.');
    } finally {
      setLoading(false);
    }
  };

  return {
    login,
    setLogin,
    password,
    setPassword,
    passwordConfirm,
    setPasswordConfirm,
    loading,
    error,
    handleSubmit,
  };
}
